<template>
  <v-container>
    <v-layout
      wrap
      align-center 
      justify-center
    >
      <v-flex xs12 align-center text-center>
        <v-icon size="200">mdi-bus</v-icon>
      </v-flex>

      <v-flex mb-4 xs10>
        <v-flex xs12>
          <v-select
            outlined
            :items="startStops"
            filled
            v-model="selectedStart"
            label="Indulási hely"
            clearable
          ></v-select>
      </v-flex>
        <v-data-table
          :headers="headers"
          :items="stopTimes"
          class="elevation-1"
          
          must-sort
          sort-by="time"
          :footer-props="{ itemsPerPageText: '' }"
        >
          <template v-slot:pageText="props">
            {{ props.pageStart }} - {{ props.pageStop }} / {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import timeTableTo from '../config/timetable.json';

  export default {
    data: () => ({
      selectedStart: null,
      headers: [
        {text: 'Megálló', value: 'stop', sortable: false},
        {text: 'Hova', value: 'where', sortable: false},
        {text: 'Mikor', value: 'time'},
      ],
      timeTableTo: timeTableTo,
    }),
    computed: {
      startStops: function(){
        const set = new Set();
        this.timeTableTo.forEach(element => {
          set.add(element.stop);
        });
        return Array.from(set).sort();
      },
      stopTimes: function(){
        if(this.selectedStart){
          return this.timeTableTo.filter(elem => elem.stop == this.selectedStart);
        } else {
          return this.timeTableTo;
        }
        
      }
    },
    methods: {
      clearStart(){
        this.selectedStart = null;
      }
    }
  }
</script>

<style>

</style>
